import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { ProgressContext } from '../providers/ProgressProvider';
import { UseProgress } from '../providers/ProgressProvider/types';

const useProgress = (): UseProgress => {
  const [state, dispatch] = useContextWithErrorHandler(ProgressContext, 'ProgressProvider');
  return [state, dispatch];
};

export default useProgress;
